module.exports = __webpack_public_path__ + "static/media/boy.c79eb98b.png";